// extracted by mini-css-extract-plugin
export default {"productContainer":"PathMenu_productContainer__iS7TJ"};